import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

interface DramaCardProps {
  drama: Drama;
}

export default function DramaCard({ drama }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={drama.coverImage}
          alt={`${drama.title} - ${drama.englishTitle}`}
          title={`${drama.title} ${drama.englishTitle}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-primary-500 text-white">
            {drama.rating}
          </span>
        </div>

        {drama.status === '更新中' && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-accent-500 text-white">
              更新中
            </span>
          </div>
        )}

        {drama.isNew && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-accent-500 text-white">
              NEW
            </span>
          </div>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-xs text-white/90 line-clamp-2 leading-relaxed">
            {drama.description}
          </p>
        </div>
      </div>

      <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
        {drama.title}
      </h3>

      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{drama.updateInfo}</span>
        <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
        <span>{drama.region}</span>
      </div>

      <div className="flex flex-wrap gap-1.5 mt-2">
        {drama.tags.slice(0, 3).map((tag) => (
          <span
            key={tag}
            className="px-1.5 py-0.5 text-xs rounded bg-secondary-100 text-secondary-800"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}